export const TRIANGLE_X_CORRECTION_INDEX = 5;
export const TRIANGLE_Y_CORRECTION_INDEX = 2.5;
